@if (!item.hidden && (isGrantedRole && (!item.isCoordenador || (item.isCoordenador && isCoordenador)))) {
  <!-- normal collapsable -->
  @if (!item.url && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      role="menuitem"
      aria-haspopup="true"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="item.title"
      tabindex="0"
      (keydown.enter)="toggleOpen($event)"
      (keydown.space)="toggleOpen($event)">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      role="menuitem"
      aria-haspopup="true"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="item.title">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'"
      role="menuitem"
      aria-haspopup="true"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="item.title + (item.openInNewTab ? ' (abre em nova aba)' : '')">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()"
      role="menuitem"
      aria-haspopup="true"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="item.title"
      tabindex="0"
      (keydown.enter)="toggleOpen($event);item.function()"
      (keydown.space)="toggleOpen($event);item.function()">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      role="menuitem"
      aria-haspopup="true"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="item.title">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'"
      role="menuitem"
      aria-haspopup="true"
      [attr.aria-expanded]="isOpen"
      [attr.aria-label]="item.title + (item.openInNewTab ? ' (abre em nova aba)' : '')">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <mat-icon class="nav-link-icon" aria-hidden="true">{{item.icon}}</mat-icon>
    }
    <span class="nav-link-title" [translate]="item.translate" [matTooltip]="item.title.length > 25 ? item.title : ''">{{item.title}}</span>
    @if (item.badge) {
      <span class="nav-link-badge" [translate]="item.badge.translate"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}"
        [attr.aria-label]="item.badge.title + ' itens'">
        {{item.badge.title}}
      </span>
    }
    @if (item.badgeCompartilhada) {
      <span class="nav-link-badge-shares" matTooltip="Compartilhadas"
        [ngStyle]="{'background-color': item.badgeCompartilhada.badge.bg,'color': item.badgeCompartilhada.badge.fg}"
        [attr.aria-label]="item.badgeCompartilhada.badge.title + ' compartilhadas'">
        {{item.badgeCompartilhada.badge.title}}
      </span>
    }
    <mat-icon class="collapsable-arrow" aria-hidden="true">keyboard_arrow_right</mat-icon>
  </ng-template>
  <div class="children" [@slideInOut]="isOpen" role="menu" [attr.aria-label]="'Submenu de ' + item.title">
    @for (child of item.children; track child.id) {
      @if (child.type==='item') {
        <cdk-nav-vertical-item [item]="child" [class.hidden]="(!!child.hideable && child.canHide(child))"></cdk-nav-vertical-item>
      }
      @if (child.type==='collapsable' && item.allowGroupOfHiddenChildren) {
        <cdk-nav-vertical-collapsable
          [item]="child"
          [class.hidden]="(!!child.hideable && child.canHide(child))"
        [allowGroupOfHiddenChildren]="child.allowGroupOfHiddenChildren"></cdk-nav-vertical-collapsable>
      }
      @if (child.type==='group') {
        <cdk-nav-vertical-group [item]="child" [class.hidden]="(!!child.hideable && child.canHide(child))"></cdk-nav-vertical-group>
      }
    }
  </div>
}
